import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_down",
  "use": "arrow_down-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol viewBox=\"0 0 12 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_down\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.99996 8.88342L2.64641 5.52987L3.35352 4.82276L5.99996 7.46921L8.64641 4.82276L9.35352 5.52987L5.99996 8.88342Z\" fill=\"#C79E6B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol